import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizBlanksQuestion from "@/components/quiz/QuizBlanksQuestion.vue";
import QuizUtils from "@/util/quizUtils";
import QuizPairsMatchingQuestion from "@/components/quiz/QuizPairsMatchingQuestion.vue";
import QuizSortingQuestion from "@/components/quiz/QuizSortingQuestion.vue";
let SimpleQuiz = class SimpleQuiz extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", null);
    _defineProperty(this, "quizNbQuestions", 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "correctAnswersIds", null);
    _defineProperty(this, "answersApprovalState", null);
    _defineProperty(this, "realtimeUserAnswers", null);
  }
  mounted() {
    if (this.question) {
      this.realtimeUserAnswers = this.initRealtimeUserAnswers();
    }
  }
  initRealtimeUserAnswers() {
    if (this.question) {
      return {
        questionId: this.question.id,
        questionType: this.question.type,
        order: this.question.order,
        blanksText: this.question.blanksText,
        responsesIds: [],
        responseContent: '',
        blanksResponses: [],
        pairsMatching: [],
        itemsSorting: []
      };
    }
    return null;
  }
  get rightAnswer() {
    if (this.question && this.correctAnswersIds?.length) {
      return this.question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE ? this.correctAnswersIds : this.correctAnswersIds[0];
    }
    return null;
  }
  get userAnswers() {
    return question => {
      if (!this.realtimeUserAnswers) {
        return null;
      }
      const answersIds = this.realtimeUserAnswers?.responsesIds || [];
      if (question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE) {
        return answersIds;
      }
      return answersIds[0] || null;
    };
  }
  get userBlanksAnswers() {
    return this.realtimeUserAnswers?.blanksResponses || [];
  }
  get userPairsMatching() {
    return this.realtimeUserAnswers?.pairsMatching || [];
  }
  get userItemsSorting() {
    return this.realtimeUserAnswers?.itemsSorting || [];
  }
  get shouldDisplayAnswerValidationAlert() {
    return this.answersApprovalState !== null && (!this.isResultMode || this.answersApprovalState);
  }
  getQuestionLabel(question) {
    return `${question.order}/${this.quizNbQuestions} - ${question.label}`;
  }
  onSelectionChange(selected) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.responsesIds = Array.isArray(selected) ? selected : [selected];
    }
    this.emitQuizAnswers();
  }
  onBlankAnswerUpdate(userBlanksAnswers) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.blanksResponses = userBlanksAnswers;
      this.emitQuizAnswers();
    }
  }
  onPairMatchingUpdate(pairsMatching) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.pairsMatching = pairsMatching;
      this.emitQuizAnswers();
    }
  }
  onItemsSortingUpdate(itemsSorting) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.itemsSorting = itemsSorting;
      this.emitQuizAnswers();
    }
  }
  isBlanksQuestion(question) {
    return QuizUtils.isBlanksQuestion(question.type);
  }
  isCheckableQuestion(question) {
    return QuizUtils.isCheckableQuestion(question.type);
  }
  isPairsMatchingQuestion(question) {
    return QuizUtils.isPairsMatchingQuestion(question.type);
  }
  isSortingQuestion(question) {
    return QuizUtils.isSortingQuestion(question.type);
  }
  emitQuizAnswers() {
    return this.realtimeUserAnswers;
  }
};
__decorate([Prop({
  required: true
})], SimpleQuiz.prototype, "question", void 0);
__decorate([Prop({
  required: true
})], SimpleQuiz.prototype, "quizNbQuestions", void 0);
__decorate([Prop({
  default: false
})], SimpleQuiz.prototype, "isResultMode", void 0);
__decorate([Prop], SimpleQuiz.prototype, "correctAnswersIds", void 0);
__decorate([Prop], SimpleQuiz.prototype, "answersApprovalState", void 0);
__decorate([Emit('answerChange')], SimpleQuiz.prototype, "emitQuizAnswers", null);
SimpleQuiz = __decorate([Component({
  components: {
    QuizSortingQuestion,
    QuizPairsMatchingQuestion,
    QuizBlanksQuestion,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], SimpleQuiz);
export default SimpleQuiz;